import { useEffect } from "react";
import { changeTool } from "../../store/tool";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { deleteSelected, exitSelection } from "../../store/model";
import { RootState } from "../../store/store";

export function useKeyboard() {
    const interaction = useAppSelector((state: RootState) => state.interaction)
    const dispatch = useAppDispatch()
    const selection = useAppSelector(state => state.model.present.selected.selectedItemIds)

    useEffect(() => {
        const generalHandleKeyboard = (e: KeyboardEvent) => {
            switch (e.key) {
                case "Escape":

                    if (interaction.rubberlineData.snapPoints.length === 0) {

                        if (selection.length > 0) {

                            dispatch(exitSelection());
                        } else if (interaction.editorState === 'normal') {
                            dispatch(changeTool("select"));
                            dispatch(exitSelection());
                        }
                    }
                    break;
                case "Delete":
                    dispatch(deleteSelected());
                    dispatch(exitSelection());
                    break;
                default:
                    break;
            }
        }
        window.addEventListener("keydown", generalHandleKeyboard);
        return () => window.removeEventListener("keydown", generalHandleKeyboard)
    }, [interaction.editorState, interaction.rubberlineData, dispatch, selection])


    // useEffect(() => {
    //     const handleNumberInput = (e: KeyboardEvent) => {
    //         if (editorState === "userInput") {
    //             // console.log("pressed1:", e.key);
    //             switch (e.key) {
    //                 case "1": case "2": case "3": case "4": case "5": case "6": case "7": case "8": case "9": case "0":
    //                     dispatch(numberInput(Number.parseInt(e.key)))
    //                     break;
    //                 case "Backspace":
    //                     dispatch(numberInputBackspace())
    //                     break;
    //                 case "Tab":
    //                     dispatch(numberInputToggle())
    //                     break;
    //                 case "Escape":
    //                     dispatch(numberInputEnd());
    //                     break;
    //                 default:
    //                     break;
    //             }
    //         }
    //     }
    //     window.addEventListener("keydown", handleNumberInput);
    //     return () => window.removeEventListener("keydown", handleNumberInput);
    // }, [editorState, dispatch])
}